export default __webpack_public_path__ + "static/featureContainerImg-1a09a67b3ee9c6702e6e434ab32f90ec.png";